export default function initForumPublishForm(): void {
    document.querySelectorAll<HTMLInputElement>('.js-forum-publish-title').forEach(input => {
        const counter = input.closest('.form-col')?.querySelector<HTMLElement>('.js-forum-publish-char-current');
        if (!counter) return;

        input.addEventListener('input', () => {
            counter.textContent = String(input.value.length);
        });
    });
}
